import axiosClient from './axiosClient';

const liveSessionApi = {
  get: (params) => {
    const url = '/user-events/get-events-live';
    return axiosClient.get(url, { params });
  },
  getLearnerJoin: (id, status) => {
    const url = `/user-events/get-users-event/${id}`;
    return axiosClient.get(url, { params: { status } });
  },
  joinEvent: (eventId) => {
    const url = `/user-events/${eventId}/join`;
    return axiosClient.get(url);
  },
  getEnrolledLearner: (id) => {
    const url = `/user-events/get-event-users/${id}`;
    return axiosClient.get(url);
  },
  sessionUser: (id, data) => {
    const url = `/session-users/update-video-access/${id}`;
    return axiosClient.put(url, data);
  },
  videoAccess: (id) => {
    const url = `/user-events/get-event-users/${id}?videoAccess=true`;
    return axiosClient.get(url);
  },
};

export default liveSessionApi;
